// extracted by mini-css-extract-plugin
export default {"modalWrap":"Modal_modalWrap__EKEyw","title":"Modal_title__ABnZP"};